
import { initializeApp } from "firebase/app";

export const BRANDNAME = "Global Finance";

export const TransactionStatus = {
    PENDING: 0,
    CONFIRMED: 1,
    CANCELLED: 2,
}

export const plans = [ 
    {
      name: "Plan 1",
      min: 200,
      max: 1999,
      duration: "6 days",
      Profits: 12,
      referralCommission: 5,
      days: 6,
      id: 0,
    },
    {
      name: "Plan 2",
      min: 2000,
      max: 29999,
      duration: "6 days",
      Profits: 18,
      referralCommission: 5,
      days: 6,
      id: 1,
    },
    {
      name: "Plan 3",
      min: 30000,
      max: 99999,
      duration: "6 days",
      Profits: 24,
      referralCommission: 5,
      days: 6,
      id: 2,
    },
    {
      name: "Plan 4",
      min: 100000,
      max: Number.POSITIVE_INFINITY,
      duration: "6 days",
      Profits: 30,
      referralCommission: 5,
      days: 6,
      id: 3,
    },
  ];
  
export const planx = [ 
    {
      name: "Plan 1",
      min: 200,
      max: 1999,
      duration: "6 days",
      Profits: 12,
      referralCommission: 5,
      days: 6,
      id: 0,
    },
    {
      name: "Plan 2",
      min: 2000,
      max: 29999,
      duration: "6 days",
      Profits: 18,
      referralCommission: 5,
      days: 6,
      id: 1,
    },
    {
      name: "Plan 3",
      min: 30000,
      max: 99999,
      duration: "6 days",
      Profits: 24,
      referralCommission: 5,
      days: 6,
      id: 2,
    },
    {
      name: "Plan 4",
      min: 100000,
      max: Number.POSITIVE_INFINITY,
      duration: "6 days",
      Profits: 30,
      referralCommission: 5,
      days: 6,
      id: 3,
    },
  ];
  
export const emptyPlan = {
    name: "none",
    min: 0,
    max: 0,
    duration: "0 days",
    Profits: 0,
    referralCommission: 0,
    days: 0,
    amount: 0,
    id: 8230,
  }

  const firebaseConfig = {
    apiKey: "AIzaSyBgqK3BZPIj9pQwzKvtnlqBKRjRLs9TJO4",
    authDomain: "globalfinancez.firebaseapp.com",
    projectId: "globalfinancez",
    storageBucket: "globalfinancez.appspot.com",
    messagingSenderId: "195513769792",
    appId: "1:195513769792:web:144a845d63c959498d24a5"
  };

  // Initialize Firebase
initializeApp(firebaseConfig);
export function FireApp() {
 
}
